import { useState } from "react";

export const useSelectItemApi = () => {
  // current selection state, contains a list of all stencil ids that are selected
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  // select a stencil and replace selection state with that single stencil
  const selectItem = (id: string) => {
    setSelectedItems([id]);
  };

  // add a stencil id to selection state
  const addItem = (id: string) => {
    setSelectedItems((prevState) => (prevState.includes(id) ? prevState : [...prevState, id]));
  };

  // remove stencil id from selection state
  const removeItem = (id: string) => {
    setSelectedItems((prevState) => prevState.filter((item) => item !== id));
  };

  // clear all selected stencil ids
  const clearItems = () => {
    setSelectedItems([]);
  };

  return { selectedItems, selectItem, addItem, removeItem, clearItems };
};

export type SelectItemApi = ReturnType<typeof useSelectItemApi>;

export const DEFAULT_SELECT_ITEM_API: SelectItemApi = {
  selectedItems: [],
  selectItem: () => undefined,
  addItem: () => undefined,
  removeItem: () => undefined,
  clearItems: () => undefined,
};
